function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M753.2 512c0 8.8-3.4 17.6-10.1 24.4L329.6 949.9c-13.4 13.5-35.3 13.5-48.7 0-13.5-13.4-13.5-35.3 0-48.7L670 512 280.9 122.8c-13.5-13.6-13.5-35.2 0-48.8 13.4-13.4 35.3-13.4 48.7 0l413.5 413.6c6.7 6.8 10.1 15.6 10.1 24.4z",
    style: {
      fill: "#333"
    }
  }));
};
export default SvgRight;